const ENABLED_CURRENCIES = ["BTC", "ETH", "SOL", "XRP"];
const ENABLED_FORWARD_CURRENCIES = ["BTC", "ETH"];
const SUPPORTED_CURRENCIES = ["BTC", "ETH", "LTC", "SOL", "XRP", "USD", "USDC"];
const IN_COIN_CURRENCIES = ["BTC", "ETH"];
const TRADE_ENABLED_CURRENCIES = ["BTC", "ETH"];

// Sentinel underlying-currency filter value for the "Equities" selector option. Not a real
// currency ticker, so it can't collide with a base_currency name from the API.
const EQUITIES_FILTER = "EQUITIES";

export {
  ENABLED_CURRENCIES,
  ENABLED_FORWARD_CURRENCIES,
  EQUITIES_FILTER,
  IN_COIN_CURRENCIES,
  SUPPORTED_CURRENCIES,
  TRADE_ENABLED_CURRENCIES,
};
